import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAdminAuth } from "../../context/AdminAuthContext";
import { ADMIN_DASHBOARD_PATH } from "../../lib/adminPaths";
import { ApiError } from "../../lib/api";

export default function AdminLoginPage() {
  const { user, loading, login } = useAdminAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!loading && user) {
    return <Navigate to={ADMIN_DASHBOARD_PATH} replace />;
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setError("");
    setSubmitting(true);

    try {
      await login(username, password);
    } catch (err) {
      const message =
        err instanceof ApiError
          ? err.message
          : err instanceof TypeError
            ? "Can't reach the API — make sure cjphotos-api is running locally."
            : "Something went wrong — try again in a moment.";
      setError(message);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="admin-page admin-page--centered">
      <div className="admin-card admin-card--narrow">
        <p className="admin-eyebrow">CJ PHOTOS</p>
        <h1 className="admin-title">Admin sign in</h1>
        <p className="admin-lede">Operator access only.</p>

        <form className="admin-form" onSubmit={handleSubmit}>
          <label className="admin-field">
            <span className="admin-label">Username</span>
            <input
              className="admin-input"
              type="text"
              name="username"
              autoComplete="username"
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              disabled={submitting || loading}
              required
            />
          </label>

          <label className="admin-field">
            <span className="admin-label">Password</span>
            <input
              className="admin-input"
              type="password"
              name="password"
              autoComplete="current-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              disabled={submitting || loading}
              required
            />
          </label>

          {error ? (
            <p className="admin-error" role="alert">
              {error}
            </p>
          ) : null}

          <button className="admin-button" type="submit" disabled={submitting || loading}>
            {submitting ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
